import type { EventStoryblok } from '@/types'

export const useEvents = (event: EventStoryblok) => {
  const { t } = useI18n()

  const hasBooth = computed(() => !!event.booth)
  const imageWidth = computed(() => {
    return {
      width: Number(event.image_width)
        ? `${Number(event.image_width)}px`
        : '100%',
    }
  })
  const representatives = computed(() => event.representatives ?? [])
  const ctaLabel = computed(() =>
    representatives.value?.length && representatives.value.length > 1
      ? t('common.events.plural_event_cta')
      : t('common.events.singular_event_cta'),
  )

  return {
    representatives,
    imageWidth,
    hasBooth,
    ctaLabel,
  }
}
